import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import HipobuySpreadsheetGuide from "@/pages/article/hipobuy-spreadsheet-guide/page";
import HipobuySpreadsheetReview from "@/pages/article/hipobuy-spreadsheet-review/page";
import HipobuySpreadsheetSafety from "@/pages/article/hipobuy-spreadsheet-safety/page";
import KakobuySpreadsheetGuide from "@/pages/article/kakobuy-spreadsheet-guide/page";
import CSSBuySpreadsheetGuide from "@/pages/article/cssbuy-spreadsheet-guide/page";
import SuperbuySpreadsheetGuide from "@/pages/article/superbuy-spreadsheet-guide/page";
import OopbuySpreadsheetReview from "@/pages/article/oopbuy-spreadsheet-review/page";
import HipobuyVsSuperbuy from "@/pages/article/hipobuy-vs-superbuy/page";
import BestHipobuyResources from "@/pages/article/best-hipobuy-resources/page";
import HipobuyProductDatabase from "@/pages/article/hipobuy-product-database/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/hipobuy-spreadsheet-guide",
    element: <HipobuySpreadsheetGuide />,
  },
  {
    path: "/hipobuy-spreadsheet-review",
    element: <HipobuySpreadsheetReview />,
  },
  {
    path: "/hipobuy-spreadsheet-safety",
    element: <HipobuySpreadsheetSafety />,
  },
  {
    path: "/kakobuy-spreadsheet-guide",
    element: <KakobuySpreadsheetGuide />,
  },
  {
    path: "/cssbuy-spreadsheet-guide",
    element: <CSSBuySpreadsheetGuide />,
  },
  {
    path: "/superbuy-spreadsheet-guide",
    element: <SuperbuySpreadsheetGuide />,
  },
  {
    path: "/oopbuy-spreadsheet-review",
    element: <OopbuySpreadsheetReview />,
  },
  {
    path: "/hipobuy-vs-superbuy",
    element: <HipobuyVsSuperbuy />,
  },
  {
    path: "/best-hipobuy-resources",
    element: <BestHipobuyResources />,
  },
  {
    path: "/hipobuy-product-database",
    element: <HipobuyProductDatabase />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;